<template>
  <div class="mt-4 card" data-testid="partner-categories">
    <div>
      <h2 class="txt-headline-3xl-bold text-main">{{ t('PartnerCompany.interests') }}</h2>
      <p class="mt-2">{{ t('PartnerCompany.interestsDescription') }}</p>
      <hr class="dark:bg-gray-700 my-4 h-px border-0 bg-surface-elevation-5" />
    </div>

    <div v-if="interests.length" class="mt-10 flex flex-wrap gap-4">
      <button
        v-for="interest in interests"
        :key="interest.id"
        class="shrink-0 rounded-sm border px-3 py-1.5 text-body-s-bold"
        :class="
          isInterestSelected(interest)
            ? 'border-primary-subtle bg-primary-subtler text-primary'
            : 'border-subtle bg-surface-elevation-2 text-subtle'
        "
        :data-testid="`partner-category-${interest.id}`"
        @click="toggleInterest(interest)"
      >
        {{ interest.name }}
      </button>
    </div>
  </div>
</template>
<script setup lang="ts">
import { useI18n } from 'vue-i18n'

import type { InterestsQuery } from '@/gql/myomr'

type Interest = InterestsQuery['interests']['nodes'][number]

const MAX_INTERESTS = 4
const { t } = useI18n()

const model = defineModel<string[]>({
  default: () => [],
})

defineProps<{
  v$: object
  interests: NonNullable<Array<Interest>>
}>()

function isInterestSelected(interest: Interest) {
  return model.value.includes(interest.id)
}

function toggleInterest(interest: Interest) {
  const selected = isInterestSelected(interest)

  if (!selected && model.value.length < MAX_INTERESTS) {
    model.value = [...model.value, interest.id]
  } else if (selected) {
    model.value = model.value.filter((id) => id !== interest.id)
  }
}
</script>
